import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const AboutUs = () => {

    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <>
            <section>
                <div className="inn-body-section">
                    <div className="container">
                        <div className="page-head">
                            <h2 style={{ 'fontSize': '33px' }}>About Us</h2>
                            <div className="head-title">
                                <div className="hl-1"></div>
                                <div className="hl-2"></div>
                                <div className="hl-3"></div>
                            </div>
                            <p>Where Comfort Meets Care – That’s Younic Home.</p>
                        </div>

                        <div className="content-section">
                            <section class="content-section container mt-5">
                                <article>
                                    <p>
                                        In today’s fast-paced world, finding a place that feels like home — where you feel safe, valued, and at peace — is rare.
                                        That’s the gap Younic Home set out to fill.
                                    </p>

                                    <p>
                                        Founded under the umbrella of <strong className='text-black'>Younic Limited</strong>, Younic Home began its journey with a simple yet powerful vision:
                                        to redefine urban accommodation by combining affordability with a deep sense of care and community.
                                        What started as a small initiative has now evolved into a trusted brand serving hundreds of residents across Dhaka.
                                    </p>

                                    <strong>Who We Serve</strong>
                                    <ul>
                                        <li>Students looking for a secure, supportive environment near their universities or coaching centers.</li>
                                        <li>Jobholders and professionals needing convenient, fully-managed living spaces near workplaces.</li>
                                        <li>Women and mothers who want peace of mind, privacy, and community.</li>
                                        <li>Anyone seeking short- or long-term affordable housing in a well-managed, respectful setting.</li>
                                    </ul>

                                    <strong>What We Offer</strong>
                                    <ul>
                                        <li><strong className='text-black'>Well-Planned Living Spaces:</strong> From bunk beds to private zones, every inch is designed with comfort in mind.</li>
                                        <li><strong className='text-black'>24/7 Security:</strong> CCTV monitoring and on-site staff ensure constant protection and privacy.</li>
                                        <li><strong className='text-black'>Generator Backup:</strong> Power outages are no worry — enjoy uninterrupted living.</li>
                                        <li><strong className='text-black'>Daily Housekeeping:</strong> Clean, fresh, and well-maintained surroundings, every day.</li>
                                        <li><strong className='text-black'>High-Speed Internet:</strong> Stay connected with fast and reliable Wi-Fi.</li>
                                        <li><strong className='text-black'>Personal Storage Spaces:</strong> Keep your belongings safe and organized.</li>
                                    </ul>

                                    <strong>Unique Offerings</strong>
                                    <ul>
                                        <li><strong className='text-black'>$2.99/Day Living:</strong> Our pricing model is designed to help you live well without breaking the bank.</li>
                                        <li><strong className='text-black'>“Care & Comfort for Mothers” Package:</strong> At our Uttara Female Branch, we offer special care for expecting and new mothers, ensuring physical wellness and emotional support.</li>
                                        <li><strong className='text-black'>Women-Only Branches:</strong> Our female residents enjoy a respectful, secure, and empowering living environment.</li>
                                        <li><strong className='text-black'>Google Verified:</strong> Multiple branches are verified on Google Business Profile, showing transparency and credibility.</li>
                                    </ul>

                                    <strong>Our Technology & Operations</strong>
                                    <p>
                                        With a 30 lakh taka investment in CRM systems and a centralized supply chain, our operations are smooth, professional, and scalable.
                                        Every complaint, request, and maintenance issue is handled through a digital platform — ensuring speed, accuracy, and satisfaction.
                                    </p>

                                    <strong>Our Philosophy</strong>
                                    <ul>
                                        <li>Everyone deserves a clean and secure place to live.</li>
                                        <li>Affordable living should not mean compromise.</li>
                                        <li>Community and care create a better society.</li>
                                    </ul>
                                    <p>
                                        Our team works tirelessly to build a culture where residents don’t just live — they thrive.
                                    </p>

                                    <strong>The Road Ahead</strong>
                                    <p>
                                        As we grow, our mission remains clear:
                                        To expand across Bangladesh and beyond, offering a new lifestyle standard for the modern generation —
                                        one that blends technology, trust, and heart.
                                    </p>

                                    <blockquote class="blockquote mt-4">
                                        <p class="mb-0">Younic Home is more than a roof over your head.<br />It’s where you belong.</p>
                                    </blockquote>
                                </article>
                            </section>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default AboutUs;
